export interface GuardianFormSubmission {
    status: AthleticFormSubmissionStatus,
    formDataJson: string,
    files?: AthleticFormSubmissionFileDto[]
    guardianSignatureRequirement: AthleticFormGuardianSignatureRequirement,
    guardians: EncryptedGuardianSignature[]
}

export type GuardianFormSubmissionParsed = {
    formData: FormFieldItemValue[]
} & GuardianFormSubmission

export enum AthleticFormGuardianSignatureRequirement {
    None = 0,
    OneGuardian = 1,
    AllGuardians = 2
}

export const signatureRequirementLabel = {
    [AthleticFormGuardianSignatureRequirement.None]: 'None',
    [AthleticFormGuardianSignatureRequirement.OneGuardian]: 'Requires the signature of one guardian.',
    [AthleticFormGuardianSignatureRequirement.AllGuardians]: 'Requires the signature of all guardians.'
}

export enum AthleticFormSubmissionStatus {
    NotStarted = 0,
    InProgress = 1,
    AwaitingGuardianSignature = 3,
    Submitted = 2,        
}

export interface AthleticFormSubmissionFileDto {
    mediaId: string;
    title: string;
    order: number;
    created: Date;
}

export interface EncryptedGuardianSignature {
    id: string;
    fullName: string;
    isActive: boolean;
    signatureMediaId?: string;
    signatureDate?: Date;
    email: string;
}

export interface FormFieldItemValue {
  fieldId: string;
  decimalValue?: number;
  stringValue?: string;
  dateTimeOffsetValue?: string;
  boolValue?: boolean;
}